function initHeroDottedLines(options) {
    var gsapInstance = options && options.gsapInstance;
    var prefersReducedMotion = !!(options && options.prefersReducedMotion);
    var dottedLineElements = document.querySelectorAll('.hero__page__dotted-line, .dotted-line');
    var svgNamespace = 'http://www.w3.org/2000/svg';

    if (!gsapInstance || !dottedLineElements.length) {
        return;
    }

    function getNumberValue(value, fallbackValue) {
        var parsedValue = parseFloat(value);

        return isNaN(parsedValue) ? fallbackValue : parsedValue;
    }

    function getCssVariableValue(element, variableName, fallbackValue) {
        var variableValue = window.getComputedStyle(element).getPropertyValue(variableName).trim();

        return variableValue || fallbackValue;
    }

    function getCssVariableNumber(element, variableName, fallbackValue) {
        return getNumberValue(getCssVariableValue(element, variableName, ''), fallbackValue);
    }

    function createSvgNode(tagName) {
        return document.createElementNS(svgNamespace, tagName);
    }

    function getLinePosition(rawValue, containerHeight, fallbackValue) {
        if (typeof rawValue !== 'string') {
            return fallbackValue;
        }

        var normalizedValue = rawValue.trim();

        if (!normalizedValue) {
            return fallbackValue;
        }

        if (normalizedValue.slice(-1) === '%') {
            return (getNumberValue(normalizedValue.slice(0, -1), 50) / 100) * containerHeight;
        }

        return getNumberValue(normalizedValue, fallbackValue);
    }

    function ensureHeroDottedLineNodes(container) {
        var svg = container.querySelector('[data-hero-dotted-line-svg]');
        var path = container.querySelector('[data-hero-dotted-line-path]');
        var isHeroPage = container.classList.contains('hero__page__dotted-line');
        var isDottedLine = container.classList.contains('dotted-line');
        var svgClass = isHeroPage ? 'hero__page__dotted-line__svg' : 'dotted-line__svg';
        var pathClass = isHeroPage ? 'hero__page__dotted-line__path' : 'dotted-line__path';

        if (!svg) {
            svg = createSvgNode('svg');
            svg.classList.add(svgClass);
            svg.setAttribute('data-hero-dotted-line-svg', 'true');
            svg.setAttribute('aria-hidden', 'true');
            container.appendChild(svg);
        }

        if (!path) {
            path = createSvgNode('path');
            path.classList.add(pathClass);
            path.setAttribute('data-hero-dotted-line-path', 'true');
            svg.appendChild(path);
        }

        return {
            svg: svg,
            path: path
        };
    }

    function buildCurvedPathData(options) {
        var dashOverscan = options.dashOverscan;
        var width = options.width;
        var baseY = options.yPosition;
        var turnInset = options.turnInset;
        var turnRadius = options.turnRadius;
        var upperRunLength = options.returnLength;
        var betweenTurnsLength = options.betweenTurnsLength;
        var secondTurnRadius = options.secondTurnRadius;
        var secondReturnLength = options.secondReturnLength;
        var firstHandle = turnRadius * 0.5522847498;
        var firstTurnStartX = Math.max(-dashOverscan, width - turnInset - turnRadius);
        var firstTurnPeakX = Math.min(width + dashOverscan, firstTurnStartX + turnRadius);
        var upperY = baseY - (turnRadius * 2);
        var firstReturnEndX = Math.max(-dashOverscan, firstTurnStartX - upperRunLength);
        var secondHandle;
        var secondTurnEntryX;
        var secondTurnPeakX;
        var secondTrackY;
        var secondReturnEndX;

        if (turnRadius <= 0) {
            return 'M ' + (-dashOverscan) + ' ' + baseY + ' H ' + (width + dashOverscan);
        }

        if (secondTurnRadius <= 0) {
            return [
                'M', -dashOverscan, baseY,
                'H', firstTurnStartX,
                'C', firstTurnStartX + firstHandle, baseY, firstTurnPeakX, baseY - turnRadius + firstHandle, firstTurnPeakX, baseY - turnRadius,
                'C', firstTurnPeakX, baseY - turnRadius - firstHandle, firstTurnStartX + firstHandle, upperY, firstTurnStartX, upperY,
                'H', firstReturnEndX
            ].join(' ');
        }

        secondHandle = secondTurnRadius * 0.5522847498;
        secondTurnEntryX = Math.max(-dashOverscan + secondTurnRadius, firstReturnEndX - betweenTurnsLength);
        secondTurnPeakX = Math.max(-dashOverscan, secondTurnEntryX - secondTurnRadius);
        secondTrackY = upperY - (secondTurnRadius * 2);
        secondReturnEndX = Math.max(width + dashOverscan, secondTurnEntryX + secondReturnLength);

        return [
            'M', -dashOverscan, baseY,
            'H', firstTurnStartX,
            'C', firstTurnStartX + firstHandle, baseY, firstTurnPeakX, baseY - turnRadius + firstHandle, firstTurnPeakX, baseY - turnRadius,
            'C', firstTurnPeakX, baseY - turnRadius - firstHandle, firstTurnStartX + firstHandle, upperY, firstTurnStartX, upperY,
            'H', secondTurnEntryX,
            'C', secondTurnEntryX - secondHandle, upperY, secondTurnPeakX, upperY - secondTurnRadius + secondHandle, secondTurnPeakX, upperY - secondTurnRadius,
            'C', secondTurnPeakX, upperY - secondTurnRadius - secondHandle, secondTurnEntryX - secondHandle, secondTrackY, secondTurnEntryX, secondTrackY,
            'H', secondReturnEndX
        ].join(' ');
    }

    function refreshHeroDottedLine(container) {
        var dashLength = getCssVariableNumber(container, '--hero-dash-length', 16);
        var dashGap = getCssVariableNumber(container, '--hero-dash-gap', 12);
        var dashCycle = dashLength + dashGap;
        var strokeWidth = getCssVariableNumber(container, '--hero-dash-thickness', 2);
        var animationDuration = getCssVariableNumber(container, '--hero-dash-duration', 1.2);
        var animationDirection = getCssVariableNumber(container, '--hero-dash-direction', 1);
        var strokeColor = getCssVariableValue(container, '--hero-dash-color', 'rgba(255, 255, 255, 0.8)');
        var strokeLinecap = getCssVariableValue(container, '--hero-dash-linecap', 'round');
        var yValue = getCssVariableValue(container, '--hero-dash-y', '50%');
        var requestedTurnRadius = getCssVariableNumber(container, '--hero-dash-turn-radius', 120);
        var width = container.clientWidth;
        var height = Math.max(container.clientHeight, strokeWidth);
        var yPosition = getLinePosition(yValue, height, height / 2);
        var returnLength = getCssVariableNumber(container, '--hero-dash-return-length', Math.min(width * 0.2, 220));
        var betweenTurnsLength = getCssVariableNumber(container, '--hero-dash-between-turns', 270);
        var requestedSecondTurnRadius = getCssVariableNumber(container, '--hero-dash-second-turn-radius', 120);
        var secondReturnLength = getCssVariableNumber(container, '--hero-dash-second-return-length', Math.min(width * 0.16, 180));
        var turnInset = getCssVariableNumber(container, '--hero-dash-turn-inset', 24);
        var maxTurnRadius;
        var turnRadius;
        var upperTrackY;
        var maxSecondTurnRadius;
        var secondTurnRadius;
        var pathData;
        var nodes = ensureHeroDottedLineNodes(container);

        if (container.heroDottedLineTween) {
            container.heroDottedLineTween.kill();
            container.heroDottedLineTween = null;
        }

        if (!width || !height || !dashCycle) {
            return;
        }

        yPosition = Math.max(0, Math.min(height, yPosition));
        maxTurnRadius = Math.max(0, (yPosition - strokeWidth) / 2);
        turnRadius = Math.min(requestedTurnRadius, maxTurnRadius);
        upperTrackY = yPosition - (turnRadius * 2);
        if (!requestedSecondTurnRadius) {
            requestedSecondTurnRadius = turnRadius * 0.72;
        }
        maxSecondTurnRadius = Math.max(0, (upperTrackY - strokeWidth) / 2);
        secondTurnRadius = Math.min(requestedSecondTurnRadius, maxSecondTurnRadius);
        pathData = buildCurvedPathData({
            dashOverscan: dashCycle,
            width: width,
            yPosition: yPosition,
            turnInset: turnInset,
            turnRadius: turnRadius,
            returnLength: returnLength,
            betweenTurnsLength: betweenTurnsLength,
            secondTurnRadius: secondTurnRadius,
            secondReturnLength: secondReturnLength
        });

        nodes.svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
        nodes.svg.setAttribute('width', width);
        nodes.svg.setAttribute('height', height);
        nodes.svg.setAttribute('preserveAspectRatio', 'none');

        nodes.path.setAttribute('d', pathData);
        nodes.path.setAttribute('fill', 'none');
        nodes.path.setAttribute('stroke', strokeColor);
        nodes.path.setAttribute('stroke-width', strokeWidth);
        nodes.path.setAttribute('stroke-dasharray', dashLength + ' ' + dashGap);
        nodes.path.setAttribute('stroke-dashoffset', '0');
        nodes.path.setAttribute('stroke-linecap', strokeLinecap);
        nodes.path.setAttribute('stroke-linejoin', 'round');
        nodes.path.setAttribute('vector-effect', 'non-scaling-stroke');

        gsapInstance.set(nodes.path, {
            strokeDashoffset: 0
        });

        if (prefersReducedMotion) {
            return;
        }

        container.heroDottedLineTween = gsapInstance.to(nodes.path, {
            strokeDashoffset: dashCycle * animationDirection * -1,
            duration: animationDuration,
            ease: 'none',
            repeat: -1
        });
    }

    function initHeroDottedLine(container) {
        if (!container) {
            return;
        }

        refreshHeroDottedLine(container);

        if (container.heroDottedLineObserver || container.heroDottedLineResizeHandler) {
            return;
        }

        if (window.ResizeObserver) {
            container.heroDottedLineObserver = new window.ResizeObserver(function () {
                refreshHeroDottedLine(container);
            });
            container.heroDottedLineObserver.observe(container);
            return;
        }

        container.heroDottedLineResizeHandler = function () {
            refreshHeroDottedLine(container);
        };
        window.addEventListener('resize', container.heroDottedLineResizeHandler);
    }

    Array.prototype.forEach.call(dottedLineElements, function (container) {
        initHeroDottedLine(container);
    });
}

module.exports = initHeroDottedLines;
